import { handleRedirectUrlCheck } from '../common/redirectUrlCheck';
import axiosClient from '../libs/axiosClient';
import { setToken } from './auth';

export const handleAppleLogin = async () => {
  window.AppleID.auth.init({
    clientId: 'us.ondoc.login',
    scope: 'name email',
    redirectURI: `${window.location.origin}/auth/apple/callback`,
    state: 'origin:web',
    // nonce: '[NONCE]',
    usePopup: true,
  });

  try {
    const res = await window.AppleID.auth.signIn();
    let code = res.authorization.code;
    let id_token = res.authorization.id_token;

    axiosClient
      .post(
        '/func/user/login/apple',
        {
          code: code,
          id_token: id_token,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': 'https://api.us.ondoc.co.kr',
          },
          withCredentials: true,
        },
      )
      .then((res) => {
        setToken(res.data);
        let rurl = localStorage.getItem('rurl');
        if (handleRedirectUrlCheck(rurl || '/'))
          window.location.href = rurl || '/';
        else window.location.href = '/';
      })
      .catch((err) => {
        alert(err.response.data.detail);
        window.location.href = '/login';
      });
  } catch (error) {
    console.log(error);
  }
};
